// src/features/system/orchestrator/api/handlersApi.ts
import { bff } from '@/lib/http/bff';

export interface Handler {
  handler_key: string;
  worker_id: number;
  description?: string | null;
  timeout_sec: number;
  max_retries: number;
  backoff_ms: number;
  priority: number;
  category?: string | null;
  tags: string[];
  config?: unknown;
  ability_key?: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface ListHandlersParams {
  active?: boolean;
  worker_id?: number;
  ability_key?: string;
}

export const fetchHandlersApi = (params: ListHandlersParams = {}): Promise<Handler[]> =>
  bff.get<Handler[]>('/orchestrator/handler-registry', {
    active     : params.active,
    worker_id  : params.worker_id,
    ability_key: params.ability_key,
  });

export interface CreateHandlerInput {
  handler_key: string;
  worker_id: number;
  description?: string;
  timeout_sec?: number;
  max_retries?: number;
  backoff_ms?: number;
  priority?: number;
  category?: string;
  tags?: string[];
  config?: unknown;
  ability_key?: string;
  is_active?: boolean;
}

export const createHandlerApi = (payload: CreateHandlerInput): Promise<Handler> =>
  bff.post<Handler>('/orchestrator/handler-registry', payload);
